import { apiFetch } from "./client.js";
export const getWater = (date) => apiFetch(`/water${date ? `?date=${date}` : ""}`);
export const setWater = (glasses) => apiFetch("/water", { method: "PUT", body: JSON.stringify({ glasses }) });
//# sourceMappingURL=water.js.map